export const DocumentCheckIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width="26"
      height="100%"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      {...props}
    >
      <g>
        <path
          d="M21 5V1H3V23H21V19"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path d="M7 7H13" strokeLinecap="round" />
        <path d="M7 12H11" strokeLinecap="round" />
        <path d="M7 17H13" strokeLinecap="round" />
        <path d="M25 8.37868L20.8787 12.5L18.5 10.1213" strokeLinecap="round" />
      </g>
    </svg>
  );
};
